import { Box } from "@mui/material";
import { Client, Role, Setup, User } from "../../../assets/svg-icons";
import { processNodeAndPermissions } from "../../../helper/com-helper";
import { superAdminUser } from "../../../helper/commonHelper";
import { DS_DASHBOARD } from "./DS_DASHBOARD";
import images from "../../../constant/images";
const isSuperAdmin = superAdminUser && superAdminUser();


const ID_OBJECT = {
  name: "Internal Dashboard",
  route: isSuperAdmin ? "/admin/client" : "/admin/setup",
  permissions: [],
  child: {
    Clients: {
      name: "Clients",
      shortName: "Clients",
      icon: Client,
      route: "/admin/client",
      permissions: ["CLIENT_VIEW"],
      roles: [],
    },
    Setup: {
      name: "Setup",
      shortName: "Setup",
      icon: Setup,
      route: "/admin/setup",
      permissions: ["BU_VIEW"],
      roles: ["Client Admin"],
    },
    Configuration: {
      name: "Configuration",
      shortName: "Config",
      route: "/admin/configuration",
      permissions: ["CLIENT_VIEWCONFIGURATION"],
      roles: ["Client Admin"],
      icon: () => <Box component="img" src={images.candle} />
    },
    Users: {
      name: "Users",
      shortName: "Users",
      icon: User,
      route: "/admin/user",
      permissions: ["USER_VIEW"],
      roles: [],
    },
    Roles: {
      name: "Roles",
      shortName: "Roles",
      icon: Role,
      route: "/admin/role",
      permissions: ["ROLE_VIEW"],
      roles: [],
    },
    Jobs: {
      name: "Job Schedule",
      shortName: "Jobs",
      icon: Role,
      route: "/admin/job",
      permissions: ["SCHEDULED_JOBS_VIEW"],
      roles: [],
    },
    "Integration Hub": {
      name: "Integration Hub",
      shortName: "IH",
      icon: Role,
      route: "/admin/integration",
      permissions: ["USER_VIEW"],
      roles: [],
    },
    "DS Dashboard": DS_DASHBOARD,
  },
  extraRoutes: [
    {
      route: "/admin/integration/details",
      permissions: ["USER_VIEW"],
      roles: [],
    },
    {
      route: "/admin/client/edit",
      permissions: ["CLIENT_EDIT"],
      roles: [],
    },
    {
      route: "/admin/setup/create",
      permissions: ["BU_CREATE"],
      roles: [],
    },
    {
      route: "/admin/setup/edit",
      permissions: ["BU_EDIT"],
      roles: [],
    },
    {
      route: "/admin/setup/configuration",
      permissions: ["BU_VIEWCONFIGURATION"],
      roles: [],
    },
    {
      route: "/admin/setup/team",
      permissions: ["TEAM_VIEW"],
      roles: [],
    },
    {
      route: "/admin/setup/team/create",
      permissions: ["TEAM_CREATE"],
      roles: [],
    },
    {
      route: "/admin/setup/team/edit",
      permissions: ["TEAM_EDIT"],
      roles: [],
    },
    {
      route: "/admin/setup/team/user",
      permissions: ["USER_VIEW"],
      roles: [],
    },
    {
      route: "/admin/user/create",
      permissions: ["USER_CREATE"],
      roles: [],
    },
    {
      route: "/admin/user/edit",
      permissions: ["USER_EDIT"],
      roles: [],
    },
    {
      route: "/admin/role/edit",
      permissions: ["ROLE_EDIT"],
      roles: [],
    },
  ],
};

processNodeAndPermissions(ID_OBJECT);
export const ID = ID_OBJECT;
